<template>
    <div id="signature-container">
        <VueSignaturePad ref="signaturePad" />

        <button class="btn btn-primary" @click="save">Save</button>
    </div>
</template>

<script>
import VueSignaturePad from "vue-signature-pad";

export default {
    props: {
        savePath: {
            required: true,
            type: String
        }
    },
    components: {
        VueSignaturePad
    },
    methods: {
        async save() {
            const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
            if (!isEmpty) {
                try {
                    await axios.put(this.savePath, {
                        signature: data
                    });
                    location.reload();
                } catch (err) {
                    console.error(err);
                }
            }
        }
    }
};
</script>

<style lang="scss" scoped>
#signature-container {
    background: #fff;
}
</style>
